import { render, staticRenderFns } from "./Celular.vue?vue&type=template&id=5865d441"
import script from "./Celular.vue?vue&type=script&lang=ts"
export * from "./Celular.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports